import { createFileRoute } from "@tanstack/react-router";
import { CommunityPage } from "@/components/community/community-ui";
import { SocialConnectSection } from "@/components/app/social-connect-section";
import { breadcrumbScript, seo } from "@/lib/seo";

const DESCRIPTION = "Follow the official Instagram, YouTube and Telegram channels for The Quantum Minds, or contact us by email.";

export const Route = createFileRoute("/community/social")({
  head: () => ({
    ...seo({ title: "Community Channels — The Quantum Minds", description: DESCRIPTION, path: "/community/social" }),
    scripts: [breadcrumbScript([
      { name: "Home", path: "/" },
      { name: "Our Community", path: "/community" },
      { name: "Community Channels", path: "/community/social" },
    ])],
  }),
  component: CommunitySocialPage,
});

function CommunitySocialPage() {
  return (
    <CommunityPage
      eyebrow="Official Channels"
      title="Our Community"
      description="Stay connected for updates, study content, announcements and support."
      backTo="/community"
    >
      <SocialConnectSection />
    </CommunityPage>
  );
}
